// eslint-disable-next-line no-redeclare,no-unused-vars
function isRead(read) {
  if (isPlainObject(read)) return checkWhere({}, read);
  else if (isArray(read)) return checkWhere({}, {role: read});
  else if (read) return true;
  else return false;
}
